import DashboardComponent from "../components/Dashboard";

const DashboardScreen = () => {
  return (
    <div style={{ padding: "24px 32px", minHeight: "calc(100vh - 80px)" }}>
      <DashboardComponent />
    </div>
  );
};

export default DashboardScreen;
